import { render, staticRenderFns } from "./linePrice.vue?vue&type=template&id=b328a2c0&scoped=true"
import script from "./linePrice.vue?vue&type=script&lang=js"
export * from "./linePrice.vue?vue&type=script&lang=js"
import style0 from "./linePrice.vue?vue&type=style&index=0&id=b328a2c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b328a2c0",
  null
  
)

export default component.exports